import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Popconfirm } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProjectStage } from '@/schemas'

interface StageDeleteProps {
  stage: ProjectStage
  onSuccess: () => void
}

export const StageDelete: React.FC<StageDeleteProps> = ({ stage, onSuccess }) => {
  const { t } = useTranslation()
  const { run } = useRequest(
    {
      url: '/api/project/deleteProjectStage',
      method: 'delete',
      params: {
        selfId: stage.selfId,
        id: stage.id,
      },
    },
    {
      manual: true,
      onSuccess,
    }
  )

  return (
    <Popconfirm
      title={t('remove confirm')}
      okText={t('remove')}
      cancelText={t('cancel')}
      okButtonProps={{ danger: true }}
      icon={<QuestionCircleOutlined style={{ color: '#e11d48' }} />}
      onConfirm={() => run()}
    >
      <Button
        className='ml-auto opacity-0 group-hover:opacity-100'
        danger
        size='small'
        shape='circle'
        icon={<CloseOutlined />}
        onClick={(e) => e.stopPropagation()}
      />
    </Popconfirm>
  )
}
